import { TimingUtils } from 'record-it-utils/utils/TimingUtils/TimingUtils';

export class UseEntitiesChangedListenerUtils {
  private constructor() {}

  public static rateLimitTimeout = 0;

  public static waitForRateLimit(): Promise<void> {
    return TimingUtils.wait(this.rateLimitTimeout);
  }
}
